import { jsx } from 'react/jsx-runtime';
import { shallow as shallow$1 } from '../../../node_modules/zustand/esm/shallow.js';
import useAlertStore from '../../store/alerts.js';
import UpgradePromptModal from '../../pricing/components/UpgradePromptModal/UpgradePromptModal.js';

const UpgradePromptDisplay = ({ alert: upgradePrompt }) => {
  const removeAlert = useAlertStore((state) => state.removeAlert, shallow$1);
  const elementId = `upgrade_prompt-${upgradePrompt.id}`;
  return /* @__PURE__ */ jsx(UpgradePromptModal, {
    title: upgradePrompt.title,
    limitBadge: upgradePrompt.limitBadge,
    tier: upgradePrompt.tier,
    onClose: () => removeAlert(upgradePrompt.id),
    planEntitlement: upgradePrompt.planEntitlement
  }, elementId);
};

export { UpgradePromptDisplay as default };
//# sourceMappingURL=UpgradePromptDisplay.js.map
